import { ApolloClient, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import fetch from 'isomorphic-fetch';

import introspectionQueryResultData from './fragmentTypes.json';
import { getSession } from '../../src/services/useSession';
import { getShareToken } from '../../src/services/shares';
import { errorLink, responseErrorNormalizerLink } from './apollo-link-error';
import errorNotifier from './apollo-known-error-notifier';
import versionTrackerLink from './apollo-version-tracker';
import requestRuntimeLoggerLink from './apollo-request-runtime-logger';

const cache = new InMemoryCache({
  possibleTypes: introspectionQueryResultData.__schema.types.reduce((acc, type) => {
    if (type.possibleTypes) {
      acc[type.name] = type.possibleTypes.map((t) => t.name);
    }
    return acc;
  }, {}),
 });
const httpLink = new HttpLink({ uri: `${process.env.GATSBY_API_URL}/graphql` });

const authLink = setContext((_, { headers }) => {
  // don't overwrite an existing Authorization header
  if (headers && headers.Authorization) {
    return headers;
  }

  const additionalHeaders = {};

  const { accessToken } = getSession();
  if (accessToken) {
    additionalHeaders["Authorization"] = `Bearer ${accessToken}`;
  }

  const shareToken = getShareToken();
  if (shareToken) {
    additionalHeaders["X-ShareToken"] = shareToken;
  }

  return {
    headers: {
      ...headers,
      ...additionalHeaders,
    },
    requestStartedAt: new Date(),
  };
});

const client = new ApolloClient({
  cache,
  fetch,
  link: ApolloLink.from([
    authLink, // inserts Authorization header
    responseErrorNormalizerLink, // fixes malformed errors before they reach the errorLink
    errorLink, // catches errors and handles them, such as refreshing the accessToken
    errorNotifier, // notifies the user when they hit a known error
    versionTrackerLink, // notifies the user when new version of this React app is available
    requestRuntimeLoggerLink, // outputs slow requests to console.warn
    httpLink, // runs the query
  ]),
});

export default client;
